import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
export function InternalLink(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      noScroll = _ref.noScroll;

  var clickHandler = function clickHandler(e) {
    e.preventDefault();
    e.target.blur();

    if (!noScroll) {
      window.scrollTo({
        top: 0,
        left: 0
      });
    }

    onClick();
  };

  return /*#__PURE__*/_jsx("a", {
    href: "#",
    onClick: clickHandler,
    children: children
  });
}
InternalLink.propTypes = {
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func.isRequired,
  noScroll: PropTypes.bool
};
InternalLink.defaultProps = {
  noScroll: false
};